import { Benefit, RedeemServiceError } from '@sitegen/common/types/redemption.types';
import { RedemptionActions } from './redemption.actions';
import { SAVE_BENEFITS, SAVE_REDEMPTION_PLATFORMS } from './redemption.constants';
import { PLATFORM_TYPES } from '@sitegen/common/constants/platforms';
import { RECYCLE_REDEMPTION_PROCESS } from '../redemption.constants';

export interface IRedemptionState {
    fetching: boolean | null;
    benefits: Benefit[]| null;
    platforms: PLATFORM_TYPES[] | null;
    error: RedeemServiceError | null;
}
export const initialState: IRedemptionState = {
    fetching: null,
    benefits: null,
    error: null,
    platforms: null
};

export const reducerKey = 'redemptionV2' as const;

export const redemptionReducer = (state: IRedemptionState = initialState, action: RedemptionActions): IRedemptionState => {
    switch (action.type) {
    case SAVE_REDEMPTION_PLATFORMS:
        return {
            ...state,
            platforms: action.payload
        };
    case SAVE_BENEFITS: {
        return {
            ...state,
            benefits: action.payload
        };
    }
    case RECYCLE_REDEMPTION_PROCESS: {
        return {
            ...initialState
        };
    }
    default:
        return state;
    }
};

export default redemptionReducer;
